import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { Overhead, TId } from 'src/app/models';
import { ProcessSheetOverheadsResource } from '../process-sheet-overheads.resource';

@Component({
  selector: 'app-process-sheet-overheads-add',
  templateUrl: './process-sheet-overheads-add.component.html',
  styleUrl: './process-sheet-overheads-add.component.sass',
  standalone: false,
})
export class ProcessSheetOverheadsAddComponent extends GenericCrudAddComponent<Overhead> {
  overheadsForPick: Overhead[] = [];

  override async preFetch(): Promise<void> {
    if (!this.resource) {
      const processSheetId = this.initialFormValues?.processSheetId as TId | undefined;
      if (!processSheetId) {
        throw new Error('processSheetId is required');
      }
      this.resource = new ProcessSheetOverheadsResource(this.api, processSheetId);
    }

    const plantId = this.initialFormValues?.plantId as TId | undefined;
    const companyId = this.api.auth.userValue?.lastCompanyId;
    if (!plantId || !companyId) {
      this.overheadsForPick = [];
      return;
    }

    const linked = new Set((this.initialFormValues?.linkedOverheadIds as TId[] | undefined) ?? []);
    const overheadsByPlant = this.api.resources.overheads.contextualizeQueryParams({
      companyId: String(companyId),
      plantId: String(plantId),
    });
    const candidates = await firstValueFrom(overheadsByPlant.getAll());
    // Lookup: overheads de la planta del full de procés, excloent els ja vinculats.
    this.overheadsForPick = candidates.filter(
      (o) => o.id && o.plantId === plantId && !linked.has(o.id),
    );
  }

  private get linkedOverheadIds(): TId[] {
    return (this.initialFormValues?.linkedOverheadIds as TId[] | undefined) ?? [];
  }

  override initFormGroup(): FormGroup {
    return this.fb.group({
      overheadId: [null],
    });
  }

  protected override async validateEntity(): Promise<boolean> {
    const overheadId = this.form!.value.overheadId as TId | null;
    if (overheadId && this.linkedOverheadIds.includes(overheadId)) {
      this.alertSrv.error(this.tr.instant('entity.processSheet.overheadAlreadyLinked'));
      return false;
    }
    return super.validateEntity();
  }

  protected override async mapFormEntity(): Promise<Partial<Overhead> & { overheadId: TId }> {
    const v = this.form!.value as { overheadId: TId };
    return { overheadId: v.overheadId };
  }
}
